import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container mt-5" }
const _hoisted_2 = { class: "card modern-card" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_5 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "payment-info mb-4" }
const _hoisted_8 = { class: "info-content" }
const _hoisted_9 = { class: "info-row" }
const _hoisted_10 = { class: "info-value" }
const _hoisted_11 = { class: "info-row" }
const _hoisted_12 = { class: "info-value" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "fa fa-spinner fa-spin me-2"
}
const _hoisted_15 = {
  key: 1,
  class: "fas fa-wallet me-2"
}
const _hoisted_16 = { class: "mt-3 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("h4", { class: "mb-0" }, [
          _createElementVNode("i", { class: "fas fa-mobile-alt me-2" }),
          _createTextVNode(" Paiement Mobile Money / Carte ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "spinner-border text-primary" }, null, -1),
              _createElementVNode("p", { class: "mt-3 text-muted" }, "Préparation du paiement...", -1)
            ]))]))
          : (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-exclamation-circle me-2" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.error), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[5] || (_cache[5] = _createElementVNode("h5", { class: "info-title" }, "Détails du paiement", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "info-label" }, "Référence BESC", -1)),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.bescRef), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "info-label" }, "Montant", -1)),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.formatNumber(_ctx.amount)) + " " + _toDisplayString(_ctx.currency), 1)
                    ])
                  ])
                ]),
                _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"alert alert-info-custom mb-4\" data-v-123e669c><div class=\"alert-header\" data-v-123e669c><i class=\"fas fa-info-circle me-2\" data-v-123e669c></i><span data-v-123e669c>Moyens de paiement acceptés</span></div><ul class=\"payment-methods\" data-v-123e669c><li data-v-123e669c><i class=\"fas fa-check-circle me-2\" data-v-123e669c></i>Mobile Money (MTN, Moov, etc.)</li><li data-v-123e669c><i class=\"fas fa-check-circle me-2\" data-v-123e669c></i>Cartes Visa / Mastercard</li></ul></div>", 1)),
                _createElementVNode("button", {
                  class: "btn btn-primary btn-payment w-100",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openKKiaPay && _ctx.openKKiaPay(...args))),
                  disabled: _ctx.isProcessing
                }, [
                  (_ctx.isProcessing)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                    : (_openBlock(), _createElementBlock("i", _hoisted_15)),
                  _createTextVNode(" " + _toDisplayString(_ctx.isProcessing ? 'Traitement en cours...' : 'Payer maintenant'), 1)
                ], 8, _hoisted_13),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_router_link, {
                    to: "/liste-besc",
                    class: "btn btn-outline-secondary btn-cancel"
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createElementVNode("i", { class: "fas fa-arrow-left me-2" }, null, -1),
                      _createTextVNode(" Annuler et retourner ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-center mt-4" }, [
                  _createElementVNode("small", { class: "secure-badge" }, [
                    _createElementVNode("i", { class: "fas fa-lock me-1" }),
                    _createTextVNode(" Paiement sécurisé par KKiaPay ")
                  ])
                ], -1))
              ]))
      ])
    ])
  ]))
}